import BaseSelectroPresenter from './BaseSelectroPresenter';
import {
  type SelectroTemplates,
  type SelectroText,
} from '@aha-app/selectro-v2';
import terminology from 'javascripts/terminology';

// This is the definition for the ideas SelectroPresenter,
// to use it import IdeasSelectroPresenter from SelectroPresenters/index.ts
// that file exports the singleton instance of this class.
class IdeasSelectroPresenterDefinition extends BaseSelectroPresenter {
  baseTemplates(): SelectroTemplates {
    return {};
  }

  baseText(): SelectroText {
    return {
      searchPlaceholder: `Search by name or ${terminology('project')}`,
    };
  }
}

export default IdeasSelectroPresenterDefinition;
